/**
 * Export loadData calls from ducks modules of different containers
 */
import { loadData as AuthenticationPageLoader } from './AuthenticationPage/AuthenticationPage.duck';
import { setInitialValues as CheckoutPageInitialValues } from './CheckoutPage/CheckoutPage.duck';
import { loadData as CMSPageLoader } from './CMSPage/CMSPage.duck';
import { loadData as ContactDetailsPageLoader } from './ContactDetailsPage/ContactDetailsPage.duck';
import { loadData as EditListingPageLoader } from './EditListingPage/EditListingPage.duck';
import { loadData as EmailVerificationPageLoader } from './EmailVerificationPage/EmailVerificationPage.duck';
import { loadData as InboxPageLoader } from './InboxPage/InboxPage.duck';
import { loadData as LandingPageLoader } from './LandingPage/LandingPage.duck';
import { loadData as ListingPageLoader } from './ListingPage/ListingPage.duck';
import { loadData as ManageListingsPageLoader } from './ManageListingsPage/ManageListingsPage.duck';
import { loadData as PaymentMethodsPageLoader } from './PaymentMethodsPage/PaymentMethodsPage.duck';
import { loadData as PrivacyPolicyPageLoader } from './PrivacyPolicyPage/PrivacyPolicyPage.duck';
import { loadData as ProfilePageLoader } from './ProfilePage/ProfilePage.duck';
import { loadData as ManageFavouritesPageLoader } from './ManageFavouritesPage/ManageFavouritesPage.duck';
import { loadData as SavedSearchesPageLoader } from './SavedSearchesPage/SavedSearchesPage.duck';
import { loadData as SearchPageLoader } from './SearchPage/SearchPage.duck';
import { loadData as StripeDashboardPageLoader } from './StripeDashboardPage/StripeDashboardPage.duck';
import { loadData as SellerEconomyPageLoader } from './SellerEconomyPage/SellerEconomyPage.duck';
import { loadData as FreightPageLoader } from './FreightPage/FreightPage.duck';
import { loadData as SellerDashboardPageLoader } from './SellerDashboardPage/SellerDashboardPage.duck';
import { loadData as StripePayoutPageLoader } from './StripePayoutPage/StripePayoutPage.duck';
import { loadData as TermsOfServicePageLoader } from './TermsOfServicePage/TermsOfServicePage.duck';
import { loadData as SubUsersPageLoader } from './SubUsersPage/SubUsersPage.duck';
import { loadData as BuyListingPageLoader } from './BuyListingPage/BuyListingPage.duck';
import { loadData as AccessRequestPageLoader } from './AccessRequestPage/AccessRequestPage.duck';
import {
  setInitialValues as TransactionPageInitialValues,
  loadData as TransactionPageLoader,
} from './TransactionPage/TransactionPage.duck';
import {
  loadData as SeoPagesLoader,
  loadDemandCars as SeoDemandCarsLoader,
} from './SeoPages/SeoPages.duck';
import { loadData as AISearchPageLoader } from './AISearchPage/AISearchPage.duck';

const getPageDataLoadingAPI = () => {
  return {
    AuthenticationPage: {
      loadData: AuthenticationPageLoader,
    },
    LandingPage: {
      loadData: LandingPageLoader,
    },
    CheckoutPage: {
      setInitialValues: CheckoutPageInitialValues,
    },
    CMSPage: {
      loadData: CMSPageLoader,
    },
    ContactDetailsPage: {
      loadData: ContactDetailsPageLoader,
    },
    EditListingPage: {
      loadData: EditListingPageLoader,
    },
    EmailVerificationPage: {
      loadData: EmailVerificationPageLoader,
    },
    InboxPage: {
      loadData: InboxPageLoader,
    },
    ListingPage: {
      loadData: ListingPageLoader,
    },
    ManageListingsPage: {
      loadData: ManageListingsPageLoader,
    },
    PaymentMethodsPage: {
      loadData: PaymentMethodsPageLoader,
    },
    PrivacyPolicyPage: {
      loadData: PrivacyPolicyPageLoader,
    },
    ProfilePage: {
      loadData: ProfilePageLoader,
    },
    SavedSearchesPage: {
      loadData: SavedSearchesPageLoader,
    },
    ManageFavouritesPage: {
      loadData: ManageFavouritesPageLoader,
    },
    SearchPage: {
      loadData: SearchPageLoader,
    },
    StripePayoutPage: {
      loadData: StripePayoutPageLoader,
    },
    StripeDashboardPage: {
      loadData: StripeDashboardPageLoader,
    },
    SellerEconomyPage: {
      loadData: SellerEconomyPageLoader,
    },
    FreightPage: {
      loadData: FreightPageLoader,
    },
    SellerDashboardPage: {
      loadData: SellerDashboardPageLoader,
    },
    TermsOfServicePage: {
      loadData: TermsOfServicePageLoader,
    },
    TransactionPage: {
      loadData: TransactionPageLoader,
      setInitialValues: TransactionPageInitialValues,
    },
    SubUsersPage: {
      loadData: SubUsersPageLoader,
    },
    BuyListingPage: {
      loadData: BuyListingPageLoader,
    },
    AccessRequestPage: {
      loadData: AccessRequestPageLoader,
    },
    // SEO landing pages. The duck's loadData is a factory bound to the page
    // type so /dack and /falgar share one component but filter listings and
    // render copy differently.
    SeoTireModelPage: {
      loadData: SeoPagesLoader('tire'),
    },
    SeoRimModelPage: {
      loadData: SeoPagesLoader('rim'),
    },
    // The AI-search answer pages (P25009-408). Same component, a third page
    // type: package listings only, plus a fit table and a direct answer.
    SeoPackageModelPage: {
      loadData: SeoPagesLoader('package'),
    },
    SeoPackageIndexPage: {
      loadData: SeoDemandCarsLoader(),
    },
    // AI search as a third mode (P25009-447): /sok?fraga=…
    AISearchPage: {
      loadData: AISearchPageLoader,
    },
    // ManageSubscriptionPage: {
    //   loadData: ManageSubscriptionPageLoader
    // }
  };
};

export default getPageDataLoadingAPI;
